var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crud-wrapper"},[_c('crud',{key:_vm.reRender,attrs:{"form-component":_vm.RequestForm,"grid-columns":_vm.gridColumns,"gridSettings":{noNew: true},"grid-options":_vm.gridOptions,"obj":"request"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0473cd0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Requests.vue
// module id = null
// module chunks = 